// Role → capability map for campaigns. Single source of truth consumed by
// useCampaignPermissions and the getActions helper. Matches UX doc §5.

import { ROLE } from './constants';

const ZERO = {
  canViewList: false,
  canSeeAllStores: false,
  canSeeDeleted: false,
  canCreate: false,
  canEdit: false,
  canLaunch: false,
  canPause: false,
  canResume: false,
  canDelete: false,
  canRestore: false,
  canHardDelete: false,
  canConnectMailchimp: false,
  canExportAudience: false,
  canViewAnalytics: false,
  canViewCrossStoreAnalytics: false,
};

const OWNER = {
  ...ZERO,
  canViewList: true,
  canCreate: true,
  canEdit: true,
  canLaunch: true,
  canPause: true,
  canResume: true,
  canDelete: true,
  canConnectMailchimp: true,
  canExportAudience: true,
  canViewAnalytics: true,
};

const ASSISTANT = {
  ...OWNER,
  canSeeAllStores: true,
  canSeeDeleted: true,
  canRestore: true,
  canViewCrossStoreAnalytics: true,
};

const DARK_ADMIN = {
  ...ASSISTANT,
  canHardDelete: true,
};

export const CAPABILITIES_BY_ROLE = {
  [ROLE.OWNER]: OWNER,
  [ROLE.ASSISTANT]: ASSISTANT,
  [ROLE.DARK_ADMIN]: DARK_ADMIN,
  [ROLE.TEACHER]: ZERO,
  [ROLE.READER]: ZERO,
};

export const capabilitiesForRole = (role) => CAPABILITIES_BY_ROLE[role] ?? ZERO;
